/**
 * @param preferenceCenter {HTMLElement}
 * @param onChange {(checked: boolean) => void}
 * @return {void}
 */
module.exports = function listenToPreferenceCenterUnsubscribeAllChange(preferenceCenter, onChange) {
    preferenceCenter.querySelectorAll('[name="unsubscribeAll"]').forEach(unsubscribeAllSwitch => {
        unsubscribeAllSwitch.addEventListener("change", ev => {
            if (ev.target instanceof HTMLInputElement) {
                onChange(ev.target.checked);
            }
        });
    });
}
